import { supabase } from './supabase';
import { uploadFile as storageUploadFile } from '@/integrations/supabase/storage';
import { getProxiedImageUrl } from '@/services/imageProxyService';

export const uploadFile = async (file: File): Promise<string> => {
  try {
    // Upload to the "img" bucket - explicitly set bucket name
    const fileUrl = await storageUploadFile(file, 'img');
    
    // Return the direct Supabase URL without proxying
    return fileUrl;
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};
